import { render, staticRenderFns } from "./formAnswer.vue?vue&type=template&id=7bb7c44c"
import script from "./formAnswer.vue?vue&type=script&lang=js"
export * from "./formAnswer.vue?vue&type=script&lang=js"
import style0 from "./formAnswer.vue?vue&type=style&index=0&id=7bb7c44c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports